import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { getMaximumStays } from "../getMaximumStays";
import { getMinimumStays } from "../getMinimumStays";

export const useRoomManagement = ({
  selectedRatePlanId,
  selectedRoomId,
  selectedDate,
  closeout,
  minimumStay,
  maximumStay,
  setCloseout,
  setAvailableRooms,
  setMinimumStay,
  setMaximumStay,
}) => {
  const handleAvailabilityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setAvailableRooms(e.target.value);

    // Check if availability is 0 to close out the room automatically
    if (value === 0) {
      setCloseout((prevCloseout) => ({
        ...prevCloseout,
        [selectedRoomId]: {
          ...prevCloseout[selectedRoomId],
          [selectedDate.format("DD-MM-YYYY")]: true,
        },
      }));
    }
  };

  const handleMinimumStayChange = (e) => {
    const dateKey = selectedDate.format("DD-MM-YYYY");
    const currentArray = minimumStay[selectedRoomId]?.[dateKey] || [];
    const updatedArray = getMinimumStays({
      minimumStays: currentArray,
      selectedRatePlanId,
      value: e.target.value,
    });

    setMinimumStay({
      ...minimumStay,
      [selectedRoomId]: {
        ...minimumStay[selectedRoomId],
        [dateKey]: updatedArray,
      },
    });
  };

  const handleMaximumStayChange = (e) => {
    const dateKey = selectedDate.format("DD-MM-YYYY");
    const currentArray = maximumStay[selectedRoomId]?.[dateKey] || [];
    const updatedArray = getMaximumStays({
      maximumStays: currentArray,
      selectedRatePlanId,
      value: e.target.value,
    });
    setMaximumStay({
      ...maximumStay,
      [selectedRoomId]: {
        ...maximumStay[selectedRoomId],
        [dateKey]: updatedArray,
      },
    });
  };

  const handleCloseoutToggle = (roomId, date) => {
    const formattedDate = moment(date, "DD-MM-YYYY").format("DD-MM-YYYY");
    const isClosedOut = !closeout[roomId]?.[formattedDate];

    // Apply the same logic as in the modal to update the closeout state
    const updatedCloseout = {
      ...closeout[roomId],
      [formattedDate]: isClosedOut,
    };

    // Update the local closeout state
    setCloseout((prevCloseout) => ({
      ...prevCloseout,
      [roomId]: updatedCloseout,
    }));

    // Save the closeout status to the backend
    saveCloseoutStatus(roomId, formattedDate, isClosedOut);
  };

  const saveCloseoutStatus = async (roomId, date, isClosedOut) => {
    try {
      const updatedCloseout = {
        ...closeout[roomId],
        [date]: isClosedOut,
      };

      await axios.put("/api/rooms/updateroomavailability", {
        roomid: roomId,
        closeout: updatedCloseout,
      });

      // Optionally update the local closeout state again after saving
      setCloseout((prev) => ({
        ...prev,
        [roomId]: updatedCloseout,
      }));

      Swal.fire("Success", "Closeout status updated successfully!", "success");
    } catch (error) {
      console.error("Error updating closeout status:", error.message);
      Swal.fire("Error", "Failed to update closeout status", "error");
    }
  };

  return {
    handleAvailabilityChange,
    handleCloseoutToggle,
    handleMinimumStayChange,
    handleMaximumStayChange,
  };
};
